import React from 'react'
import StpdBannerComponent from 'stpd-ad-component'

import config from 'SRC/config/config.json'

export const Banner = () => {
  return (
    <div style={{ height: '100%', width: '100%', display: 'flex', alignItems: 'center' }}>
      <div style={{ width: 320, margin: 'auto' }}>
        <StpdBannerComponent
          refreshOnUrlChange={true}
          adUnitPath={`/${config.banners.dfpNetworkId}/${config.banners.sidebar.adDetailMobileLastPhoto.adUnit}`}
          size={config.banners.sidebar.adDetailMobileLastPhoto.sizes}
          divId={config.banners.sidebar.adDetailMobileLastPhoto.slotId}
        />
      </div>
    </div>
  )
}
